import owd from 'owd/owd';
import _ from 'underscore';

const observer = new IntersectionObserver(function(entries) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target._inviewPlay();
		} else {
			entry.target._inviewPause();
		}
	});
});

export default class Autoplay extends owd.Component {
	init() {
		this.video = this.$element[0];
		this.video.load();
		
		this.bind();
	}


	bind() {
		this.$element[0]._inviewPlay = () => {
			setTimeout(() => {
				this.video.play();
			})
        };

        this.$element[0]._inviewPause = () => {
            this.video.pause();
        };

        observer.observe(this.$element[0]);
    }

    destroy() {
		super.destroy();
	
        observer.unobserve(this.$element[0]);
    }
}

owd.registerComponent('autoplay', {
	component: Autoplay
});
